module.exports = "img/flags/AS.bff1825.png";